<div class="templateA">

    @if(_templateData.header){
        <div style="text-align: center;">
            <h1 style="margin-bottom: 0.05em;">{{_templateData.header.title}}</h1>
            <h3 style="margin-top: 0.05em;">{{_templateData.header.subTitle}}</h3>
            <div>
                @for(line of _templateData.header.lineItems; track line){
                    {{line}}<br>
                }
            </div>
        </div>
        <br>
    }

    @if (_templateData.bodyText) {
        <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
            <div style="width: 75vw;" [innerHtml]="safeHtmlBody"></div>
        </div>
        <br>
    }

    @if (_templateData.context) {
        <div style="display: flex;  flex-wrap: wrap; justify-content: space-around; align-items: stretch; width: 100%;">

        @for(card of _templateData.context; track card; let i = $index){

            <mat-card style="min-width: 300px; max-width: 450px; margin: 5px;">

                @if(!card.more) {
                    <div style="max-width: 100%; height: auto; overflow: hidden">
                        <div style="width: 100%; height: auto; display: block;">
                            <img  src="{{card.image}}" width="100%">
                        </div>
                    </div>

                    <mat-card-header>
                        <div mat-card-avatar > <mat-icon>{{card.icon}}</mat-icon></div>
                        <mat-card-title>{{card.title}}</mat-card-title>
                        <mat-card-subtitle>{{card.subTitle}}</mat-card-subtitle>
                    </mat-card-header>
                }

                @if(!card.more) {
                    <mat-card-content>
                        <p>{{card.body}}</p>
                    </mat-card-content>
                } @else {
                    <mat-card-content>
                        <p>{{card.moreBody}}</p>
                    </mat-card-content>
                }

                <mat-card-actions>
                    @if (card.button){
                        @if (card.moreBody){
                            @if (!card.more){
                                <button mat-button (click)="onMoreButtonClick(card)">Show me more</button>
                            } @else {
                                <button mat-button (click)="onMoreButtonClick(card)">Show me less</button>
                            }
                        }
                        @if (!card.more){
                            <button mat-button (click)="onButtonClick(card.button.buttonURL)">{{card.button.buttonText}}</button>
                        }
                    }
                </mat-card-actions>

            </mat-card>
        }
        </div>
        <br>
    }

    @if(_templateData.footer){
        <div style="text-align: center;">
            <h1 style="margin-bottom: 0.05em;">{{_templateData.footer.title}}</h1>
            <h3 style="margin-top: 0.05em;">{{_templateData.footer.subTitle}}</h3>
            <div>
                @for(line of _templateData.footer.lineItems; track line){
                    {{line}}<br>
                }
            </div>
        </div>
        <br>
    }

</div>